import $http from '../assets/js/http'

const mapping = {
  '1': 'icon',
  '2': 'logo',
  '3': 'image1',
  '4': 'image2',
  '5': 'image3',
  '6': 'title',
  '7': 'desc',
  '8': 'rating',
  '9': 'comments',
  '10': 'targetUrl',
  '11': 'appName',
  '12': 'appDownUrl',
  '13': 'deeplink',
  '14': 'packageName',
  '15': 'showMonitor',
  '16': 'clickMonitor',
  '17': 'video',
  '18': 'appVersion',
  '19': 'appDeveloper',
  '20': 'appFeatureUrl',
  '21': 'appPrivacyPolicyUrl',
  '22': 'appPermissionUrl',
  '23': 'downloadStartMonitor',
  '24': 'downloadFinishMonitor',
  '25': 'installStartMonitor',
  '26': 'installFinishMonitor'
}

export function toAssetId (fieldName) {
  const invertedMapping = Object.fromEntries(
    Object.entries(mapping).map(([key, value]) => [value, key])
  )
  return invertedMapping[fieldName]
}

export function getList (params, enableLoading = true) {
  $http.custom(params, {moduleId: '601', enableLoading: enableLoading})
  return $http.post('/ideatype/query/list', params)
}

export function getEntity (params) {
  $http.custom(params, {moduleId: '602'})
  return $http.post('/ideatype/query/info', params)
}

export default {
  toAssetId,
  getList,
  getEntity
}



// WEBPACK FOOTER //
// ./src/api/ideaType.js